import { RoutePath } from 'routes';

const routesAsArray: string[] = Object.values(RoutePath);

export const findRoute = (path: string) => Object.values(RoutePath).find((route) => route === path);

export const findRoutePathThatEndsWith = (pieceOfPath: string) => routesAsArray.find((routePath) => routePath.endsWith(pieceOfPath));
